import React, { createContext, useContext } from "react";

type FormValidationContextValue = {
  /** True after the user tries to submit with missing required fields */
  showErrors: boolean;
};

const FormValidationContext = createContext<FormValidationContextValue>({
  showErrors: false,
});

export const FormValidationProvider = FormValidationContext.Provider;

export function useFormValidation() {
  return useContext(FormValidationContext);
}

export function fieldShellClass(invalid: boolean): string {
  return invalid
    ? "h-full rounded-xl border border-[var(--cu-danger)] bg-[var(--cu-danger)]/5 p-3.5 ring-1 ring-[var(--cu-danger)]/40"
    : "h-full rounded-xl border border-[var(--cu-border)] bg-[var(--cu-elevated)] p-3.5";
}
